import { dataFetch } from '@lib/ggj-utils'

export default {
 
 // 获取我的G币
  async getCoin (params) {
    return dataFetch('/promotion/api/coin/getInfo', params)
  },

  // 获取G币明细列表
  async getCoinRecord (params) {
    return dataFetch('/promotion/api/coin/record', params)
  },

  // 获取g币tab列表
	async getGcoinList (params) {
		return dataFetch('/promotion/api/coin/selectDetails', params)
  },
}